
// 采购商场后台
export const LayoutRoutes = [
  {
    path: '/sgadmin',
    name: 'sgadmin',
    component: () => import('@/pages/Layout/Layout.vue'),
    meta: {
      requiresAuth: true // 添加一个 meta 字段，指示页面需要认证
    },
    redirect: '/sgadmin/cpu/cpu',
    children: [
      {
        path: '/sgadmin/cpu/cpu',
        name: 'cpu',
        meta: {
          requiresAuth: true,
          title: [{ text: "数据", name: "cpu" }],
        },
        text: "数据",
        component: () => import('@/pages/Admin/cpu/cpu.vue')
      },
      {
        path: '/sgadmin/home/autoplay',
        name: 'autoplay',
        text: "轮播图",
        meta: {
          requiresAuth: true,
          title: [{ text: "首页", name: "autoplay" }, { text: "轮播图", name: "autoplay" }],
        },
        component: () => import('@/pages/Admin/home/autoplay.vue')
      },

      {
        path: '/sgadmin/home/recommend',
        name: 'recommend',
        text: "推荐位",
        meta: {
          requiresAuth: true,
          title: [{ text: "首页", name: "autoplay" }, { text: "推荐位", name: "recommend" }],
        },
        component: () => import('@/pages/Admin/home/recommend.vue')
      },
      {
        path: '/sgadmin/home/hotword',
        name: 'hotword',
        text: "热词搜索",
        meta: {
          requiresAuth: true,
          title: [{ text: "首页", name: "autoplay" }, { text: "热词搜索", name: "hotword" }],
        },
        component: () => import('@/pages/Admin/home/hotword.vue')
      },
      {
        path: '/sgadmin/home/product',
        name: 'product',
        text: "新品",
        meta: {
          requiresAuth: true,
          title: [{ text: "首页", name: "autoplay" }, { text: "新品发现", name: "product" }],
        },
        component: () => import('@/pages/Admin/home/product.vue')
      },
      {
        path: '/sgadmin/home/brand',
        name: 'brand',
        text: "品牌推荐",
        meta: {
          requiresAuth: true,
          title: [{ text: "首页", name: "autoplay" }, { text: "品牌推荐", name: "brand" }],
        },
        component: () => import('@/pages/Admin/home/brand.vue')
      },
      {
        path: '/sgadmin/home/sort',
        name: 'sort',
        text: "排行榜",
        meta: {
          requiresAuth: true,
          title: [{ text: "首页", name: "autoplay" }, { text: "排行榜", name: "sort" }],
        },
        component: () => import('@/pages/Admin/home/sort.vue')
      },
      {
        path: '/sgadmin/shopping/title',
        name: 'title',
        text: "分类管理",
        meta: {
          requiresAuth: true,
          title: [{ text: "商品管理", name: "title" }, { text: "分类管理", name: "title" }],
        },
        component: () => import('@/pages/Admin/shopping/title.vue')
      },
      {
        path: '/sgadmin/shopping/list',
        name: 'list',
        text: "商品内容管理",
        meta: {
          requiresAuth: true,
          title: [{ text: "商品管理", name: "title" }, { text: "商品内容管理", name: "list" }],
        },
        component: () => import('@/pages/Admin/shopping/list.vue')
      },
      {
        path: '/sgadmin/home/demo6',
        name: 'demo6',
        text: "demo6",
        meta: {
          requiresAuth: true,
          title: [{ text: "首页", name: "autoplay" }, { text: "demo6", name: "demo6" }],
        },
        component: () => import('@/pages/Admin/home/demo.vue')
      },
      {
        path: '/sgadmin/home/select',
        name: 'select',
        text: "select",
        meta: {
          requiresAuth: true,
          title: [{ text: "首页", name: "autoplay" }, { text: "select", name: "select" }],
        },
        component: () => import('@/pages/Admin/home/select.vue')
      },


    ]
  },
  {
    path: '/shopping',
    name: 'shopping',
    component: () => import('@/pages/shopping/index.vue'),
    // children: []
  },
  {
    path: '/detail',
    name: 'detail',
    component: () => import('@/pages/shopping/detail.vue')
  },
  {
    path: '/cart',
    name: 'cart',
    component: () => import('@/pages/shopping/cart.vue')
  },
  {
    path: '/settle',
    name: 'settle',
    component: () => import('@/pages/shopping/settle.vue')
  },
  {
    path: '/search',
    name: 'search',
    component: () => import('@/pages/shopping/search.vue')
  },
  {
    path: '/history',
    name: 'history',
    component: () => import('@/pages/shopping/history.vue')
  },
]